import { Navigate, Route, Routes } from 'react-router-dom';
import AiClientResultDetailPage from './aiClients/AiClientResultDetailPage';
import AiClientResultsPage from './aiClients/AiClientResultsPage';
import AdminLoginPage from './auth/AdminLoginPage';
import RequireAdmin from './auth/RequireAdmin';
import ContactDetailPage from './contacts/ContactDetailPage';
import ContactListPage from './contacts/ContactListPage';
import FeedbackDetailPage from './feedback/FeedbackDetailPage';
import FeedbackListPage from './feedback/FeedbackListPage';
import InquiryDetailPage from './inquiries/InquiryDetailPage';
import InquiryListPage from './inquiries/InquiryListPage';
import AdminLayout from './layout/AdminLayout';

// /admin 하위 라우트. 로그인 화면을 뺀 모든 경로(없는 경로 포함)는 RequireAdmin을 거친다.
export default function AdminRoutes() {
    return (
        <Routes>
            <Route path="login" element={<AdminLoginPage />} />
            <Route element={<RequireAdmin><AdminLayout /></RequireAdmin>}>
                <Route index element={<Navigate to="ai-clients" replace />} />
                <Route path="ai-clients" element={<AiClientResultsPage />} />
                <Route path="ai-clients/:instanceId" element={<AiClientResultDetailPage />} />
                <Route path="feedback" element={<FeedbackListPage />} />
                <Route path="feedback/:feedbackId" element={<FeedbackDetailPage />} />
                <Route path="inquiries" element={<InquiryListPage />} />
                <Route path="inquiries/:inquiryId" element={<InquiryDetailPage />} />
                <Route path="contacts" element={<ContactListPage />} />
                <Route path="contacts/:contactId" element={<ContactDetailPage />} />
                <Route path="*" element={<Navigate to="/admin" replace />} />
            </Route>
        </Routes>
    );
}
